import { useState, useEffect } from 'react';

function trackIsVisuallyEnabled(track: any): boolean {
  if (!track) return false;
  return track.isEnabled !== false && track.muted !== true;
}

/**
 * Subscribes to Agora track state. Agora uses `track-updated` for mute/unmute; not only `enabled`/`disabled`.
 */
export default function useIsTrackEnabled(track: any): boolean {
  const [enabled, setEnabled] = useState(() => trackIsVisuallyEnabled(track));

  useEffect(() => {
    setEnabled(trackIsVisuallyEnabled(track));
    if (!track || typeof track.on !== 'function') {
      return;
    }

    const sync = () => setEnabled(trackIsVisuallyEnabled(track));

    track.on('track-updated', sync);
    track.on('enabled', sync);
    track.on('disabled', sync);

    return () => {
      track.off?.('track-updated', sync);
      track.off?.('enabled', sync);
      track.off?.('disabled', sync);
    };
  }, [track]);

  return enabled;
}
